import React, { useState, useEffect, useRef } from 'react';
import { useNavigate } from 'react-router-dom';
import './join.scss';
import axios from 'axios';
import SBNav from '../../shared/components/SideBarNav/SBNav';
import api from '../../api';
import { useAuth } from 'react-oidc-context';
import { getOrCreateClientId } from '../../context/clientIdHelper';
import { containsProfanities } from '../../shared/utils/ContainsProfanity';
const Join = () => {

    useEffect(() => {
        document.title = 'Join Room'
    }, [])

    const auth = useAuth();
    const accountAccessToken = auth.user?.access_token;
    const hasAccountSession = auth.isAuthenticated && !!accountAccessToken;

    const [inputValues, setInputValues] = useState<string[]>(Array(8).fill(''));

    const [nameInput, setNameInput] = useState(false);
    const [joinError, setJoinError] = useState('');

    const [nav, openNav] = useState(false);

    const firstInputRef = useRef<HTMLInputElement | null>(null);


    useEffect(() => {
        if (!firstInputRef) return;
        firstInputRef.current?.focus();
    }, [])


    useEffect(() => {
        if (!nav) {
            // ensure cleanup if nav is false
            document.documentElement.classList.remove("nav-blur");
            document.body.style.overflow = "";
            document.body.style.position = "";
            document.body.style.top = "";
            document.body.style.width = "";
            return;
        }


        // --- lock scroll (keeps current scroll position) ---
        const scrollY = window.scrollY;

        // add blur class to <html> (we'll define CSS below)
        document.documentElement.classList.add("nav-blur");

        // lock body in place
        document.body.style.overflow = "hidden";
        document.body.style.position = "fixed";
        document.body.style.top = `-${scrollY}px`;
        document.body.style.width = "100%";

        return () => {
            // --- restore ---
            document.documentElement.classList.remove("nav-blur");

            document.body.style.overflow = "";
            document.body.style.position = "";
            document.body.style.top = "";
            document.body.style.width = "";

            window.scrollTo(0, scrollY);
        };
    }, [nav]);


    const initialNameVal = () => {
        const flashroomName = localStorage.getItem("flashroom-accountName");

        if (!flashroomName) return '';

        return flashroomName;
    }

    const [nameVal, setNameVal] = useState(initialNameVal());

    const [roomId, setRoomId] = useState('');

    const navigate = useNavigate();

    const handleChange = (index: number, e: React.ChangeEvent<HTMLInputElement>) => {
        const newInputValues = [...inputValues];
        newInputValues[index] = e.target.value;
        setInputValues(newInputValues);
    };

    const API = process.env.REACT_APP_API_URL;

    const findRoomByCode = async (e: React.FormEvent<HTMLFormElement>) => {
        e.preventDefault();
        const condensed = inputValues.join('');
        const code = condensed.trim();
        try {
            setJoinError('');
            if (condensed.length != 8) {
                setJoinError('Enter the full 8-character room code.');
                return;
            }
            const { data } = await axios.get(`${API}/api/rooms/bycode/${code}`)

            setRoomId(data.room.id)

            setNameInput(true);

        } catch (error) {
            setJoinError('Room not found. Check the code and try again.');
        }
    }


    const joinRoom = async (e: React.FormEvent<HTMLFormElement>) => {
        e.preventDefault();
        try {
            setJoinError('');
            const trimmedName = nameVal.trim();

            if (!trimmedName) {
                setJoinError('Enter your name to join this room.');
                return;
            }

            if (containsProfanities(trimmedName)) {
                setJoinError('Choose a different display name.');
                return;
            }

            const clientId = getOrCreateClientId();

            localStorage.setItem('flashroom-accountName', trimmedName)

            if (hasAccountSession && accountAccessToken) {
                await api.patch(
                    '/users/me/display-name',
                    { displayName: trimmedName },
                    {
                        headers: {
                            Authorization: `Bearer ${accountAccessToken}`,
                        },
                    }
                );
            }

            const { data: room } = await axios.post(`${API}/api/rooms/join/${roomId}`, {
                member: {
                    name: trimmedName,
                    role: 'member',
                    clientId: clientId,
                    canEdit: false,
                    canCreate: false,
                    isAdmin: false,
                    userId: null
                }
            })

            localStorage.setItem("flashroom_roomToken", room.token);
            localStorage.setItem("flashroom_most_recent", roomId);

            navigate(`/room/${roomId}`)
        } catch (err: any) {
            if (axios.isAxiosError(err) && err.response) {
                if (err.response.status === 403 && err.response.data?.error === "banned") {
                    navigate("/kicked");
                    return;
                }
                if (err.response.data?.code === "ROOM_FULL") {
                    navigate("/room-full");
                    return;
                }
                setJoinError('Unable to join this room. Please try again.');
            }
        }
    }


    const handleKeyDown = (index: number, e: React.KeyboardEvent<HTMLInputElement>) => {
        if (e.key.length === 1 && !e.ctrlKey && !e.metaKey && !e.altKey) {
            e.preventDefault();
            const newInputValues = [...inputValues];
            newInputValues[index] = e.key;
            setInputValues(newInputValues);

            if (index < 7) {
                const nextIndex = index + 1;
                (document.getElementById(`input-${nextIndex}`) as HTMLInputElement | null)?.focus();
            }
        } else if (e.key === 'Backspace') {
            e.preventDefault();
            const currentInput = inputValues[index];

            if (currentInput === '') {
                if (index > 0) {
                    const prevIndex = index - 1;
                    (document.getElementById(`input-${prevIndex}`) as HTMLInputElement | null)?.focus();
                }
            } else {
                const newInputValues = [...inputValues];
                newInputValues[index] = '';
                setInputValues(newInputValues);
            }
        } else if (e.key === 'Enter') {
            e.preventDefault();
            const form = e.currentTarget.form;
            form?.requestSubmit();
        }
    };



    return (
        <div style={{ backgroundImage: `url('images/cbb2.png')` }} id='join-page'>
            {/* <img className='file-bg' src='images/filebg.png' /> */}


            <div className='nav-2'>
                <div className='nav-logo-container'>
                    <img src='images/flashroom-logo-light.png' height="44px" />
                    <h1>Flash<span>Room</span></h1>
                </div>


                <div className='hamburger-menu-2' onClick={() => openNav(true)}>
                    <div />
                    <div />
                    <div />
                </div>

            </div>


            <div className={`nav-cont ${nav ? 'nav-open' : 'nav-closed'}`}>

                <div className='standard-xi-cont'

                    onClick={() => openNav(false)}
                >

                    <svg className="x-icon-sbn" xmlns="http://www.w3.org/2000/svg" viewBox="0 0 111.01 111.01">
                        <g id="Layer_3" data-name="Layer 3">
                            <path
                                className="cls-1"
                                d="M232.21,289.66a10.1,10.1,0,0,1-14.31,0l-38.22-38.22-38.23,38.23a10.13,10.13,0,0,1-14.32-14.32l38.23-38.23L127.14,198.9a10.12,10.12,0,1,1,14.31-14.31l38.22,38.22,38.23-38.23a10.13,10.13,0,0,1,14.32,14.32L194,237.13l38.22,38.22A10.12,10.12,0,0,1,232.21,289.66Z"
                                transform="translate(-124.17 -181.62)"
                            />
                        </g>
                    </svg>

                </div>

                <SBNav />

            </div>

            {nameInput ? (
                <form id='join-name-form' onSubmit={joinRoom}>
                    <input maxLength={20} placeholder='enter name' type='text' value={nameVal} onChange={(e) => setNameVal(e.target.value)} />
                    {joinError && <p className="join-error" role="alert">{joinError}</p>}
                    <button type='submit'>Join</button>
                </form>
            ) : (

                <div id='join-form-container'>



                    <form id='join-form' onSubmit={findRoomByCode}>

                        <p>Enter Join Code (case sensitive)</p>
                        {joinError && <p className="join-error" role="alert">{joinError}</p>}

                        <div className='inputs'>
                            <input ref={firstInputRef} onKeyDown={(e) => handleKeyDown(0, e)} onChange={(e) => handleChange(0, e)} value={inputValues[0]} id={`input-${0}`}
                            />
                            <input onKeyDown={(e) => handleKeyDown(1, e)} onChange={(e) => handleChange(1, e)} value={inputValues[1]} id={`input-${1}`}
                            />
                            <input onKeyDown={(e) => handleKeyDown(2, e)} onChange={(e) => handleChange(2, e)} value={inputValues[2]} id={`input-${2}`}
                            />
                            <span>-</span>
                            <input onKeyDown={(e) => handleKeyDown(3, e)} onChange={(e) => handleChange(3, e)} value={inputValues[3]} id={`input-${3}`}
                            />
                            <input onKeyDown={(e) => handleKeyDown(4, e)} onChange={(e) => handleChange(4, e)} value={inputValues[4]} id={`input-${4}`}
                            />
                            <span>-</span>
                            <input onKeyDown={(e) => handleKeyDown(5, e)} onChange={(e) => handleChange(5, e)} value={inputValues[5]} id={`input-${5}`}
                            />
                            <input onKeyDown={(e) => handleKeyDown(6, e)} onChange={(e) => handleChange(6, e)} value={inputValues[6]} id={`input-${6}`}
                            />
                            <input onKeyDown={(e) => handleKeyDown(7, e)} onChange={(e) => handleChange(7, e)} value={inputValues[7]} id={`input-${7}`}
                            />
                        </div>
                        <button type='submit'>ENTER</button>
                    </form>
                </div>

            )}





        </div>
    )
}

export default Join
